import initGoogleOneTap from '../../../services/GoogleOneTap';

const MOUNT_ID = 'google-one-tap';

const element = document.getElementById(MOUNT_ID);

if (element) {
    initGoogleOneTap({
        clientId: element.dataset.clientId || '',
        authModuleUrl: element.dataset.authModule || ''
    });
}
